export const name = 'gzYouTube';

/**
 * @ngdoc directive
 * @name gazelle.components.youTube.directive:gzYoutube
 *
 * @description
 * `<gz-you-tube>` creates iframe YouTube player
 *
 * @usage
 * ```html
 * <gz-you-tube video-id='someId'></gz-you-tube>
 *
 * ```
 */
export default function gzYouTube($window, $q, $parse) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'E',
    scope: {
      videoId: '@',
      playerId: '@',
      width: '@',
      height: '@',
      playerApi: '=?',
      autoplay: '@',
      showinfo: '@',
      controls: '@',
    },
    link: gzYouTubeLink,
  };

  return directive;

  //////////////////////
  // Private functions
  function gzYouTubeLink(scope, element) {
    let tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    $window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    let player;

    if (!$window.gzYTDefer) {
      $window.gzYTDefer = $q.defer();
    }

    let videoId = $parse(scope.videoId)(scope.$parent);
    if (!videoId) {
      videoId = scope.videoId;
    }
    let autoplay = $parse(scope.autoplay)(scope.$parent);
    if (autoplay === undefined) {
      autoplay = 0;
    }
    let showinfo = $parse(scope.showinfo)(scope.$parent);
    if (showinfo === undefined) {
      showinfo = 1;
    }
    let controls = $parse(scope.controls)(scope.$parent);
    if (controls === undefined) {
      controls = 1;
    }


    $window.gzYTDefer.promise.then(() => {
     player = new YT.Player(element[0], { // jshint ignore:line
        playerVars: {
          host: 'https://www.youtube.com',
          autoplay: autoplay,
          html5: 1,
          theme: 'light',
          modesbranding: 0,
          color: 'white',
          iv_load_policy: 3,
          showinfo: showinfo,
          controls: controls,
          rel: 0,
        },
        videoId: videoId,
        events: {
          // 'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      });

      scope.playerApi = {
        play: APIPlay,
        stop: APIStop,
        pause: APIPause,
      };

      $window.addEventListener('gz-youtube-command-stop', () => {
        APIStop();
      });
    });

    function onYouTubeIframeAPIReady() {
      $window.gzYTDefer.resolve();
    }

    function APIPlay() {
      $window.gzYTDefer.promise.then(() => {
        if (player && player.playVideo) {
          player.playVideo();
        }
      });
    }

    function APIStop() {
      $window.gzYTDefer.promise.then(() => {
        if (player && player.seekTo && player.stopVideo) {
          player.seekTo(0);
          player.stopVideo();
        }
      });
    }

    function APIPause() {
      $window.gzYTDefer.promise.then(() => {
        if (player && player.pauseVideo) {
          player.pauseVideo();
        }
      });
    }

    function onPlayerReady(event) {
      let e = event;
    }

    function onPlayerStateChange(event) {
      let videoId = $parse(scope.videoId)(scope.$parent);
      switch(event.data) {
        case 1:
          $window.dispatchEvent(new window.CustomEvent('gz-youtube-play', {detail: { playerId: scope.playerId, videoId }} ));
          break;
        case 2:
          $window.dispatchEvent(new window.CustomEvent('gz-youtube-pause', {detail: { playerId: scope.playerId, videoId }} ));
          break;
        case 0:
          if (player.seekTo && player.stopVideo) {
            scope.reset = true;
            player.seekTo(0);
            player.stopVideo();
          }
          $window.dispatchEvent(new window.CustomEvent('gz-youtube-stop', {detail: { playerId: scope.playerId, videoId }} ));
          break;
        case -1:
          if (scope.reset) {
            delete scope.reset;
            $window.dispatchEvent(new window.CustomEvent('gz-youtube-stop', {detail: { playerId: scope.playerId, videoId }} ));
          }
          break;
      }
    }
  }
}
